export default __webpack_public_path__ + "static/media/map.6184c85e.png";